import React, { useContext } from "react";
import { DataContext } from "../../context/Dataprovider";
import "./style.css";

export const Carrito = () => {
  const value = useContext(DataContext);
  const [menu, setMenu] = value.menu;
  const [carrito, setCarrito] = value.carrito;
  const [total] = value.total;

  const toogleFalse = () => {
    setMenu(!menu);
  };
  const show1 = menu ? "carritos show" : "carritos";
  const sho2 = menu ? "carrito show" : "carrito";

  const resta = (id) => {
    carrito.forEach((item) => {
      if (item.id === id) {
        item.cantidad === 1 ? (item.cantidad = 1) : (item.cantidad -= 1);
      }
      setCarrito([...carrito]);
    });
  };
  const suma = (id) => {
    carrito.forEach((item) => {
      if (item.id === id) {
        item.cantidad += 1;
      }
      setCarrito([...carrito]);
    });
  };
  const removeProducto = (id) => {
    if (window.confirm("¿Quiere eliminar el producto?")) {
      carrito.forEach((item, index) => {
        if (item.id === id) {
          item.cantidad = 1;
          carrito.splice(index, 1);
        }
      });
      setCarrito([...carrito]);
    }
  };
  // const handleBuy = () => {
  //   console.log(carrito);
  //   alert(`Has comprado el producto
  //   ${carrito.title} por el precio de ${carrito.price}
  //   `);
  // };
  return (
    <div className={show1}>
      <div className={sho2}>
        <div className="carrito__close" onClick={toogleFalse}>
          <box-icon name="x"></box-icon>
        </div>
        <h2>Su carrito</h2>
        <div className="carrito__center">
          {carrito.length === 0 ? (
            <h2 style={{ textAlign: "center", fontSize: "3rem" }}>
              Carrito Vacío
            </h2>
          ) : (
            <>
              {carrito.map((producto) => (
                <div className="carrito__item" key={producto.id}>
                  <img
                    src={producto.image.default}
                    alt="images"
                    loading="lazy"
                    decoding="async"
                  />
                  <div>
                    <h3>{producto.title}</h3>
                    <p className="price">C$ {producto.price}</p>
                  </div>
                  <div className="d-flex align-items-center justify-content-center flex-column">
                    <box-icon
                      name="up-arrow"
                      type="solid"
                      onClick={() => suma(producto.id)}
                    ></box-icon>
                    <p className="cantidad mb-0">{producto.cantidad}</p>
                    <box-icon
                      name="down-arrow"
                      type="solid"
                      onClick={() => resta(producto.id)}
                    ></box-icon>
                  </div>
                  <div
                    className="remove__item"
                    onClick={() => removeProducto(producto.id)}
                  >
                    <box-icon name="trash"></box-icon>
                  </div>
                </div>
              ))}
            </>
          )}
        </div>
        <div className="carrito__footer">
          <h3>Total : C${total}</h3>
          <button className="btn btn-success">Payment</button>
        </div>
      </div>
    </div>
  );
};
